import { db } from "../firebase";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";

// Single doc holding every CMS-editable UI string as a flat {key: value}
// map — buttons, error/validation messages, instructional copy, etc. that
// aren't tied to one page's block layout (see blockRegistry.js for that).
// Mirrors siteContentService.js's draft/publish shape exactly, just with a
// flat string map instead of a blocks array.
const DOC_REF = ["siteStrings", "registry"];

/** Returns null if no admin has ever saved anything yet — callers fall
 * back to textRegistry.js's defaultValue per key. */
export async function getSiteStrings() {
  const snap = await getDoc(doc(db, ...DOC_REF));
  return snap.exists() ? snap.data() : null;
}

/** Saves the working draft without touching what's live. */
export async function saveStringsDraft(values) {
  await setDoc(
    doc(db, ...DOC_REF),
    { draft: values, updatedAt: serverTimestamp() },
    { merge: true },
  );
}

/** Publishes the current draft so the public site picks it up. */
export async function publishStrings(values, publishedBy) {
  await setDoc(
    doc(db, ...DOC_REF),
    {
      draft: values,
      published: values,
      updatedAt: serverTimestamp(),
      publishedAt: serverTimestamp(),
      publishedBy,
    },
    { merge: true },
  );
}
